import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Button from './ui/Button.jsx';
import Input from './ui/Input.jsx';
import { createInvitadoSchema } from '../lib/schemas/invitado.js';

// Form used inside the create/edit modal on the admin invitados page.
// Fields (FR-6.1): nombre (required), email (optional), telefono
// (optional), acompanantes_max (required, >= 1). Inline errors in Spanish.
export default function InvitadoForm({ mode = 'create', defaultValues, onSubmit, onCancel, submitLabel }) {
  const isEdit = mode === 'edit';
  const defaults = {
    nombre: defaultValues?.nombre ?? '',
    email: defaultValues?.email ?? '',
    telefono: defaultValues?.telefono ?? '',
    acompanantes_max: defaultValues?.acompanantes_max ?? 1,
  };

  const {
    control,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(createInvitadoSchema),
    defaultValues: defaults,
    mode: 'onTouched',
  });

  const submit = async (values) => {
    const payload = {
      nombre: values.nombre.trim(),
      email: values.email?.trim() || undefined,
      telefono: values.telefono?.trim() || undefined,
      acompanantes_max: Number(values.acompanantes_max),
    };
    await onSubmit(payload);
  };

  return (
    <form onSubmit={handleSubmit(submit)} className="flex flex-col gap-4">
      <Input
        label="Nombre"
        autoFocus
        {...register('nombre')}
        error={errors.nombre?.message}
      />
      <Input
        label="Email (opcional)"
        type="email"
        autoComplete="off"
        {...register('email')}
        error={errors.email?.message}
      />
      <Input
        label="Teléfono (opcional)"
        type="tel"
        autoComplete="off"
        {...register('telefono')}
        error={errors.telefono?.message}
      />
      <Controller
        name="acompanantes_max"
        control={control}
        render={({ field }) => (
          <Input
            label="Acompañantes máximos (cupos totales)"
            type="number"
            min={1}
            max={20}
            step={1}
            value={field.value ?? 1}
            onChange={(e) => field.onChange(e.target.value)}
            onBlur={field.onBlur}
            ref={field.ref}
            error={errors.acompanantes_max?.message}
          />
        )}
      />

      <div className="mt-2 flex justify-end gap-2">
        {onCancel && (
          <Button type="button" variant="ghost" onClick={onCancel} disabled={isSubmitting}>
            Cancelar
          </Button>
        )}
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Guardando...' : submitLabel ?? (isEdit ? 'Guardar cambios' : 'Crear invitado')}
        </Button>
      </div>
    </form>
  );
}